export default "__VITE_ASSET__BP3JBJ51__"